import React from 'react';
import './ShiftToolTip.scss';
import {
    Tooltip,
} from '@mui/material';
// eslint-disable-next-line no-unused-vars

const SegmentType = Object.freeze({
    REGULAR_SEGMENT: 1,
    TRANSFER_SEGMENT: 3,
    BREAK_SEGMENT: 4,
});

/**
 * @param {CommonClient2.ShiftTooltipProps} props
 * @returns
 */
function ShiftToolTip(props) {
    const { element, shiftInfos } = props;

    return (
        <Tooltip
            arrow
            enterDelay={500}
            enterNextDelay={500}
            classes={{
                popper: 'ShiftTooltip',
            }}
            placement="top"
            title={
                <div className="ShiftTooltipContent">
                    <div className="ShiftToolTipShiftSection">
                        <div className="ShiftTooltipShiftBlueBox">Shift</div>
                        {
                            shiftInfos.date ? (
                                <div className="ShiftTooltipShiftDate">{shiftInfos.date}</div>
                            ) : null
                        }
                        <div className="ShiftTooltipShiftTime">{shiftInfos.timeString}</div>
                    </div>
                    {
                        shiftInfos.segments.map((x, i) => (
                            <div
                                key={`ShiftToolTipSegmentsSection_${shiftInfos.id}_${x.id}`}
                                className="ShiftToolTipSegmentsSection"
                            >
                                <div className="ShiftTooltipSegmentDate" >
                                    <span className="ShiftTooltipSegmentIndex">{i + 1}</span>
                                    <span className="ShiftTooltipSegmentTime">{x.timeString}</span>
                                </div>
                                {
                                    x.segmentType !== SegmentType.BREAK_SEGMENT ? (
                                        <div className="ShiftTooltipSegmentLocation" >{x.orgJobPath}</div>
                                    ) : null
                                }
                            </div>
                        ))
                    }
                </div>
            }
        >
            {
                element
            }
        </Tooltip>
    );
}

export default ShiftToolTip;
